// src/pages/PrivacyPolicy.js
import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
   
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
      }, []);
 
      return (
    <>
      <div className="mainnav min-vh-100">
   
  <Helmet>
    <title>Privacy Policy | Narayan Salvi Namkeen Manufacturer</title>

    <meta
      name="description"
      content="Read the privacy policy of Narayan Salvi Namkeen Manufacturer. Learn how we collect, use, and protect your personal information when you visit our website."
    />

    <meta
      name="keywords"
      content="Privacy Policy, Narayan Salvi, Namkeen Manufacturer, Data Privacy, Information Protection, Contact Data Usage, Secure Website Policy"
    />

    <meta name="author" content="Narayan Salvi Namkeen Manufacturer" />

    {/* Open Graph Meta Tags */}
    <meta property="og:title" content="Privacy Policy | Narayan Salvi Namkeen Manufacturer" />
    <meta
      property="og:description"
      content="We value your privacy. Find out how we handle your personal data when you use our services."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://nsnamkeenlabourcontractor.com/privacypolicy" />
    <meta property="og:image" content="https://nsnamkeenlabourcontractor.com/images/privacy-banner.jpg" />

    {/* Viewport for responsiveness */}
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    {/* Favicon */}
    <link rel="icon" href="/favicon.ico" />
  </Helmet>
        
        <Container className="py-3">
          <Row className="justify-content-center">
            <Col xs={12} md={10}>
              <Card className="shadow-lg">
                <Card.Body>
                  <Card.Title as="h2" className="middletext mb-1" data-aos="zoom-in">Privacy Policy</Card.Title>
                  <Card.Text>
                    <p>
                      At Narayan Salvi Namkeen Manufacturer, we are committed to protecting your
                      privacy. We do not share your personal information with any third party without
                      your consent.
                    </p>
                    <p>
                      This website collects your name, email, and phone number only for contact and
                      service purposes. We ensure all data is stored securely and used only for
                      internal processing and communication.
                    </p>
                    <p>
                      By using our website, you consent to the collection and use of information as
                      outlined in this policy.
                    </p>
                    <p>
                      We reserve the right to modify this Privacy Policy at any time. Please review it
                      frequently.
                    </p>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default PrivacyPolicy;
